export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/viewer/img_page_viewer_right-2cbbc4f0acc21b7469ee8fc4ba3ceec8.gif";